import React from 'react';
import { AlertCircle } from 'lucide-react';

interface NotificationCardErrorProps {
  message: string;
  testId: string;
}

/** Inline validation error row shared by the notification cards. */
export const NotificationCardError: React.FC<NotificationCardErrorProps> = ({
  message,
  testId,
}) => (
  <div className="flex items-start gap-2 text-sm text-destructive" data-testid={testId}>
    <AlertCircle className="h-4 w-4 mt-0.5 shrink-0" />
    <span>{message}</span>
  </div>
);
